import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locale/en.json";
import es from "./locale/es.json";
import mx from "./locale/es-mx.json";

i18n.use(initReactI18next).init({
  lng: "es-MX",
  fallbackLng: {
    "es-MX": ["es", "en"],
    es: ["en"],
    default: ["es"],
  },
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: { ...en },
    es: { ...es },
    "es-MX": { ...mx },
  },
});

export default i18n;
